import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { getFontColorStyle } from '../../../../helpers/font-styles';

export type ContentColumnStyleProps = {
  textChildren: 1 | 2 | 3;
};

export const contentColumnStyles = ({ textChildren }: ContentColumnStyleProps) => [
  css`
    display: grid;
    grid-area: content;
    .content-column-title-container,
    .content-column-subtitle,
    .content-column-tertiary-title {
      margin: ${theme.spacing(0.25, 0)};
    }
  `,
  textChildren === 2 &&
    css`
      .content-column-subtitle {
        ${getFontColorStyle('light', theme)}
      }
    `,
  textChildren === 3 &&
    css`
      .content-column-subtitle {
        ${getFontColorStyle('default', theme)}
      }
      .content-column-tertiary-title {
        ${getFontColorStyle('light', theme)}
        margin: 0;
      }
    `,
];
